import { render, staticRenderFns } from "./SubscriptionAlert.vue?vue&type=template&id=5f99edb6&scoped=true"
import script from "./SubscriptionAlert.vue?vue&type=script&lang=js"
export * from "./SubscriptionAlert.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionAlert.vue?vue&type=style&index=0&id=5f99edb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f99edb6",
  null
  
)

export default component.exports